import React, { FC } from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import { Chip } from '@material-ui/core'

import { components } from '@plandi/common/src/generated'
import { useProfileDetailsStyles } from './profile-details.styles'
import { useLocale } from '@plandi/common'

type ProfileProfessionalProps = {
  type: string | string[] | undefined
  profileFreelancer?: components['schemas']['ProfileSpecialistMeResource']
  profileCompany?: components['schemas']['ProfileCompanyMeResource']
}

export const ProfileProfessional: FC<ProfileProfessionalProps> = ({
  type,
  profileFreelancer,
  profileCompany
}) => {
  const locale = useLocale()
  const classes = useProfileDetailsStyles()

  const renderProfessional = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {locale === 'ru' ? 'Профессиональные навыки' : 'Professional skills'}
        </Typography>

        <div className={classes.groupChip}>
          {type === 'freelancer'
            ? profileFreelancer?.skills?.map((skill, idx) => (
                <Chip key={idx} label={skill} />
              ))
            : profileCompany?.skills?.map((skill, idx) => (
                <Chip key={idx} label={skill} />
              ))}
        </div>
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderProfessional()}</CardContent>
    </Card>
  )
}
